const DEFAULT_QUOTE_FORM = {
  name: "",
  email: "",
  phone: "",
  project_type: "",
  description: "",
  dimensions: "",
  quantity: "",
  deadline: "",
  delivery_method: "",
  address_line_1: "",
  address_line_2: "",
  city: "",
  postcode: "",
  country: "United Kingdom",
};

export function createInitialQuoteForm(search = "") {
  const params = new URLSearchParams(search);
  const product = params.get("product") || "";
  const material = params.get("material") || "";
  const estimate = params.get("estimate") || "";
  const customDescription = params.get("description") || "";

  const generatedDescription = [
    product ? `Quote request for ${product}.` : "",
    material ? `Preferred material: ${material}.` : "",
    estimate ? `Estimated online price: ${estimate}.` : "",
  ]
    .filter(Boolean)
    .join(" ");

  return {
    ...DEFAULT_QUOTE_FORM,
    project_type: params.get("type") || "",
    description: customDescription || generatedDescription,
    dimensions: params.get("dimensions") || "",
    quantity: params.get("quantity") || "",
    deadline: params.get("deadline") || "",
  };
}

export function buildMuralQuoteUrl({
  productTitle = "",
  dimensionsText = "",
  materialLabel = "",
  estimatedPrice = 0,
  projectType = "Wall Mural",
}) {
  const params = new URLSearchParams();

  params.set("type", projectType);

  if (dimensionsText) params.set("dimensions", dimensionsText);
  if (materialLabel) params.set("material", materialLabel);
  if (productTitle) params.set("product", productTitle);
  if (estimatedPrice > 0) params.set("estimate", `£${estimatedPrice.toFixed(2)}`);

  const description = [
    productTitle ? `I'm interested in the ${productTitle}.` : "",
    dimensionsText ? `Wall size: ${dimensionsText}.` : "",
    materialLabel ? `Material: ${materialLabel}.` : "",
    estimatedPrice > 0 ? `Estimated online price: £${estimatedPrice.toFixed(2)}.` : "",
  ]
    .filter(Boolean)
    .join(" ");

  if (description) params.set("description", description);
  params.set("quantity", "1");

  return `/request-quote?${params.toString()}`;
}

export function getQuotePrefillSummary(search = "") {
  const params = new URLSearchParams(search);
  return [params.get("product"), params.get("dimensions"), params.get("material")]
    .filter(Boolean)
    .join(" • ");
}
